import React, { useState } from 'react'
import { SparklesIcon } from 'lucide-react'

type MemeCaptionRegeneratorProps = {
  imageSrc: string
  initialCaption: string
  regenerateIsDisabled: boolean
  onRegenerateClick: (caption: string) => void
}

const MemeCaptionRegenerator: React.FC<MemeCaptionRegeneratorProps> = ({
  imageSrc,
  initialCaption,
  regenerateIsDisabled,
  onRegenerateClick,
}) => {
  const [caption, setCaption] = useState(initialCaption)
  return (
    <div className='flex flex-col space-x-0 md:flex-row md:space-x-2'>
      <div className='mb-4 space-y-3 px-0 lg:mb-0 lg:pr-6'>
        <label htmlFor='meme-description' className='text-sm'>
          You can write a better description of the image below to get better
          memes
        </label>
        <input
          id='meme-description'
          className='default-input'
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
        />
        <button
          className='primary-button-solid w-full'
          disabled={regenerateIsDisabled}
          onClick={() => onRegenerateClick(caption)}
        >
          <SparklesIcon className='h-5 w-5' />
          <span>Regenerate</span>
        </button>
      </div>
      {/* TODO: ignore warning for now, fix when this component is used in the future */}
      <img // eslint-disable-line
        src={imageSrc}
        className='max-h-[400px] max-w-[400px] object-contain'
        alt=''
      />
    </div>
  )
}

export default MemeCaptionRegenerator
